module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.1cd48d7.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-icons/font/weathericons-regular-webfont.woff2
// module id = tgG5
// module chunks = 1